import React from "react";

import { createStyles, Image, Button } from "@mantine/core";
import { motion } from "framer-motion";
import { Collapse } from "@mantine/core";

const { BrandGithub } = require("tabler-icons-react");

const useStyles = createStyles((theme) => ({
  title: {
    fontSize: "128px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "bolder",

    [theme.fn.smallerThan(680)]: {
      fontSize: "84px",
    },
    [theme.fn.smallerThan(471)]: {
      fontSize: "48px",
    },
  },
  projectContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "30px",
    cursor: "pointer",

    "&:hover": {
      color: "#FDD9B5",
    },
  },
  desc: {
    color: "white",
    fontWeight: "bolder",
  },
  projectDetails: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
    fontWeight: "bold",
    marginTop: "80px",

    [theme.fn.smallerThan(900)]: {
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      gap: "30px",
    },
  },
  projectImg: {
    marginBottom: "20px",
    width: "800px",
    flex: 0.9,

    [theme.fn.smallerThan(1050)]: {
      width: "100%",
    },
  },
  projectText: {
    flex: "0 0 400px",

    [theme.fn.smallerThan(900)]: {
      flex: "none",
    },
  },
  git: {
    "&:hover": {
      cursor: "pointer",
      color: "#FDD9B5",
    },
  },
  whiteSpace: {
    whiteSpace: "pre-wrap"
  }
}));

export interface ProjectType {
  id: number;
  title: string;
  desc: string;
  details: string;
  tools: string;
  img: string;
  git?: string;
  link?: string;
}

interface ProjectProps {
  project: ProjectType;
  open: number[];
  setOpen: (open: number[]) => void;
}

const Project = (props: ProjectProps) => {
  const { project, open, setOpen } = props;
  const { id, title, desc, details, tools, img, git, link } = project;
  const { classes } = useStyles();

  const toggleProject = () => {
    if (open.includes(id)) {
      setOpen(
        open.filter((num) => {
          return id !== num;
        })
      );
    } else {
      setOpen([...open, id]);
    }
  };

  const goToUrl = (url?: string) => {
    (window as any).open(url, "_blank");
  };

  return (
    <div>
      <motion.div
        whileHover={{ x: "80px", transition: { duration: 0.25 } }}
        className={classes.projectContainer}
        onClick={toggleProject}
      >
        <div className={classes.title}>{title}</div>
        <div className={classes.desc}>{desc}</div>
      </motion.div>
      <Collapse transitionDuration={1000} in={open.includes(id)}>
        <div className={classes.projectDetails}>
          <div className={classes.projectText}>
            <p className={classes.whiteSpace}>{details}</p>
            <p>{tools}</p>
            {link && (
              <Button
                component="a"
                target="_blank"
                rel="noopener noreferrer"
                href={link}
              >
                View Project
              </Button>
            )}
            {git && (
              <div onClick={() => goToUrl(git)}>
                <BrandGithub className={classes.git} />
              </div>
            )}
          </div>
          <Image
            className={classes.projectImg}
            src={require(`images/${img}.png`)}
          />
        </div>
      </Collapse>
    </div>
  );
};

export default Project;
